var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyLinkWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.49,70,99.16,89.45a27.24,27.24,0,0,1-38.66,0,27.79,27.79,0,0,1-4.15-5.55l9-9a6.34,6.34,0,0,1,1.45-1,13.55,13.55,0,0,0,22.7,5.83l19.33-19.44a13.82,13.82,0,0,0,0-19.44,13.63,13.63,0,0,0-19.33,0l-6.87,6.92a34.16,34.16,0,0,0-17.43-1.91L79.83,31.12a27.22,27.22,0,0,1,38.66,0A27.61,27.61,0,0,1,118.49,70ZM67.38,102l-6.88,6.92a13.62,13.62,0,0,1-19.32,0,13.82,13.82,0,0,1,0-19.44L60.5,70a13.55,13.55,0,0,1,22.71,5.83,6.34,6.34,0,0,0,1.45-1l9-9a26.73,26.73,0,0,0-4.15-5.54,27.21,27.21,0,0,0-38.65,0L31.51,79.73a27.61,27.61,0,0,0,0,38.88,27.24,27.24,0,0,0,38.66,0l14.65-14.73A34.17,34.17,0,0,1,67.38,102Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkWhite);
export default __webpack_public_path__ + "static/media/copy-link-white.937ee24944098eb2f6041fe01f8bb444.svg";
export { ForwardRef as ReactComponent };